import { render, staticRenderFns } from "./gonggao.vue?vue&type=template&id=8837eb9c&scoped=true&"
import script from "./gonggao.vue?vue&type=script&lang=js&"
export * from "./gonggao.vue?vue&type=script&lang=js&"
import style0 from "./gonggao.vue?vue&type=style&index=0&id=8837eb9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8837eb9c",
  null
  
)

export default component.exports